import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { TwoFactorStatus } from '@/enums/two-factor-status.enum'
import { ApplicationState } from '@/state/root.models'

import { User, UserFilters } from '../models'
import createBackupCodesExtraReducer from '../thunks/create-backup-codes.thunk'
import deleteUserExtraReducer from '../thunks/delete.thunk'

import disableCodesExtraReducer from '../thunks/disable-code.thunk'
import getAllUsersExtraReducer from '../thunks/get-all.thunk'
import getBackupCodesExtraReducer from '../thunks/get-backup-codes.thunk'

import getSecretCodeExtraReducer from '../thunks/get-code.thunk'
import updateUserExtraReducer from '../thunks/update.thunk'
import validateCodesExtraReducer from '../thunks/validate-code.thunk'

import initialState from './initial-state'

const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    resetUserStateAction() {
      return initialState
    },
    setUserFiltersAction(state, action: PayloadAction<UserFilters>) {
      state.filters = action.payload
    },
    setTwoFactorVerifiedAction(state, action: PayloadAction<TwoFactorStatus>) {
      state.twoFactorVerified = action.payload
    },
    resetTwoFactorAction(state) {
      state.twoFactorVerified = TwoFactorStatus.INITIAL
      state.secretCode = ''
    },
    setCurrentUser(state, action: PayloadAction<User>) {
      state.currentUser = action.payload
    },
  },
  extraReducers: (builder) => {
    getSecretCodeExtraReducer(builder)
    validateCodesExtraReducer(builder)
    disableCodesExtraReducer(builder)
    getBackupCodesExtraReducer(builder)
    createBackupCodesExtraReducer(builder)
    updateUserExtraReducer(builder)
    deleteUserExtraReducer(builder)
    getAllUsersExtraReducer(builder)
  },
})

export const {
  resetUserStateAction,
  setUserFiltersAction,
  setTwoFactorVerifiedAction,
  resetTwoFactorAction,
  setCurrentUser,
} = userSlice.actions

export const usersSelector = ({ user }: ApplicationState) => user

export default userSlice
